(function () {
  'use strict';

  angular.module('lead.status').controller('LeadStatusCtrl', LeadStatusCtrl);

  LeadStatusCtrl.$inject = ['LeadStatus', '$rootScope', '$timeout'];

  function LeadStatusCtrl(LeadStatus, $rootScope, $timeout) {
    var vm = this,
      current;

    vm.statuses = LeadStatus.get();

    vm.leadStatusChange = function (statusId) {
      if (!current || current == statusId) {
        current = statusId;
        return;
      }

      LeadStatus.update(
        { id: vm.leadId },
        { status_id: statusId },
        function () {
          current = statusId;
          $rootScope.$broadcast('activity.update');
        },
      );
    };
  }
})();
